import { Stack } from "expo-router"
import { BFScreen } from "@/components/standard/screen/BFScreen"

function LayoutStacks() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: "fade",
      }}
    />
  )
}

export default () => {
  return (
    <BFScreen
      noBackButton={true}
      headerSticky={false}
      headerClassName="hidden"
      dark={true}
      gradientBackground={true}
      className="max-w-[800px] mx-auto"
    >
      <LayoutStacks />
    </BFScreen>
  )
}
